import { render } from "./AddNotificacionAlerta.vue?vue&type=template&id=0351f0f2"
import script from "./AddNotificacionAlerta.vue?vue&type=script&lang=js"
export * from "./AddNotificacionAlerta.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\esteb\\Desktop\\PlantillaEsteban\\fronted-plantilla\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__